import React from 'react';
import * as ReactGA from 'react-ga';
import Layout from '../components/Shared/Layout';
import PrivacyPolicy from '../components/privacy_policy';
import '../assets/css/privacy.css';

const $ = typeof window !== `undefined` ? require('jquery') : null;

class PrivacyPage extends React.Component {
  componentDidMount() {
    ReactGA.set({
      title: 'Privacy.Policy',
    });
    ReactGA.pageview(this.props.location.pathname);
  }

  render() {
    return (
      <Layout>
        <PrivacyPolicy />
      </Layout>
    );
  }
}

export default PrivacyPage;
